import { type RouteRecordRaw } from 'vue-router';

import { License, OrganizationFlags } from '../../models';

export const administrationRoutes: RouteRecordRaw[] = [{
    path: 'administration',
    name: 'administration',
    redirect: { name: 'administration.orders' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 6,
        index: 0,
        prependIcon: 'icon-settings',
        code: 'playdoo.routes.menu.administration'
    },
    component: () => import('./views/AdministrationView.vue'),
    children: [{
        path: 'orders/create',
        name: 'administration.orders.create',
        meta: {
            index: 0,
            code: 'playdoo.routes.administration.orders.create',
            breadcrumbs: true
        },
        component: () => import('./views/administration/CreateOrderView.vue')
    }, {
        path: 'orders',
        name: 'administration.orders',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.administration.orders'
        },
        component: () => import('./views/administration/OrdersView.vue')
    }, {
        path: 'explore/:curationCategoryId/curations/:curationId/playlists/:playlistId',
        name: 'administration.explore.curation-category.curation.playlist',
        meta: {
            licenses: {
                operator: 'or',
                licenses: [License.SPOT_AUDIO, License.SPOT_VIDEO]
            },
            organizationFlags: {
                operator: 'and',
                flags: [OrganizationFlags.PUBLISHER]
            },
            code: 'playdoo.routes.administration.explore.curation-category.curation.playlist',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/administration/CurationPlaylistView.vue')
    }, {
        path: 'explore/:curationCategoryId/curations/:curationId',
        name: 'administration.explore.curation-category.curation',
        meta: {
            licenses: {
                operator: 'or',
                licenses: [License.SPOT_AUDIO, License.SPOT_VIDEO]
            },
            organizationFlags: {
                operator: 'and',
                flags: [OrganizationFlags.PUBLISHER]
            },
            code: 'playdoo.routes.administration.explore.curation-category.curation',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/administration/CurationView.vue')
    }, {
        path: 'explore/:curationCategoryId',
        name: 'administration.explore.curation-category',
        meta: {
            licenses: {
                operator: 'or',
                licenses: [License.SPOT_AUDIO, License.SPOT_VIDEO]
            },
            organizationFlags: {
                operator: 'and',
                flags: [OrganizationFlags.PUBLISHER]
            },
            code: 'playdoo.routes.administration.explore.curation-category',
            hideTabs: true,
            breadcrumbs: true
        },
        component: () => import('./views/administration/CurationCategoryView.vue')
    }, {
        path: 'explore',
        name: 'administration.explore',
        meta: {
            licenses: {
                operator: 'or',
                licenses: [License.SPOT_AUDIO, License.SPOT_VIDEO]
            },
            organizationFlags: {
                operator: 'and',
                flags: [OrganizationFlags.PUBLISHER]
            },
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.administration.explore'
        },
        component: () => import('./views/administration/ExploreView.vue')
    }, {
        path: 'organizations',
        name: 'administration.organizations',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.administration.organizations'
        },
        component: () => import('./views/administration/OrganizationsView.vue')
    }, {
        path: 'locations',
        name: 'administration.locations',
        meta: {
            showInTabs: true,
            index: 3,
            code: 'playdoo.routes.administration.locations'
        },
        component: () => import('./views/administration/LocationsView.vue')
    }, {
        path: 'tags',
        name: 'administration.tags',
        meta: {
            showInTabs: true,
            index: 4,
            code: 'playdoo.routes.administration.tags'
        },
        component: () => import('./views/administration/TagsView.vue')
    }, {
        path: 'users',
        name: 'administration.users',
        meta: {
            showInTabs: true,
            index: 5,
            code: 'playdoo.routes.administration.users'
        },
        component: () => import('./views/administration/UsersView.vue')
    }, {
        path: 'credentials',
        name: 'administration.credentials',
        meta: {
            showInTabs: true,
            index: 6,
            code: 'playdoo.routes.administration.credentials'
        },
        component: () => import('./views/administration/CredentialsView.vue')
    }, {
        path: 'vault',
        name: 'administration.vault',
        meta: {
            showInTabs: true,
            index: 7,
            code: 'playdoo.routes.administration.vault',
            organizationFlags: {
                operator: 'and',
                flags: [OrganizationFlags.VAULT_ENABLED]
            }
        },
        component: () => import('./views/administration/VaultView.vue')
    }, {
        path: 'logo',
        name: 'administration.logo',
        meta: {
            showInTabs: true,
            index: 8,
            code: 'playdoo.routes.administration.logo'
        },
        component: () => import('./views/administration/LogoView.vue')
    }]
}];